module.exports = __webpack_public_path__ + "img/shio3.46ef9fb6.jpg";